import React from 'react';
import { useSimpleContext } from '../_context';
import { Button, Modal } from '@roo/roo';
import { submitInnovate } from '../../../assets/apis/innovate';
import { submitScientist } from '../../../assets/apis/scientist';
import { toastTip } from './ToastTip';
import { useStep } from '../_context/useData';

export function useFormSave() {
  const { state, update } = useSimpleContext((s) => [
    s.saving,
    s.handleSave,
    s.validateFields,
    s.values,
    s.disabled,
  ]);
  const { validateFields, handleSave: save, values } = state;
  const { setStep, step } = useStep();
  const { saving } = state;
  return { saving, setStep, step, validateFields, values };
}

export function Footer() {
  const { state, update } = useSimpleContext((s) => [s.saving, s.values, s.disabled]);
  const { setStep, step, saving } = useFormSave();
  return <div />
  // return (
  //   <div className={`form-plus footer ${state.isViewType ? '' : 'form-btn-x'}`}>
  //     {step > 1 && (
  //       <Button
  //         size='large'
  //         auto={false}
  //         type='hollow'
  //         loading={saving}
  //         onClick={() => {
  //           setStep(step - 1);
  //         }}
  //       >
  //         上一页
  //       </Button>
  //     )}
  //     &nbsp;&nbsp;&nbsp;
  //     {step < 3 && (
  //       <Button
  //         size='large'
  //         auto={false}
  //         type='hollow'
  //         loading={saving}
  //         onClick={() => {
  //           setStep(step + 1);
  //         }}
  //       >
  //         下一页
  //       </Button>
  //     )}
  //   </div>
  // );
}
